

<template>
  <div id="app">
    <div class="wrapper mainFlexColumn">
      <page-header :showTelephone="true" :telephone="getReseller.telephone">
        <template v-slot:logo>
          <img v-if="isStandalone || isPolFed || isTga" :src="require(`./assets/theme/${getReseller.id}/images/${getReseller.logo}.png`)" class="brand-logo"/>
          <div v-if="isTiga && isTif">
            <img :src="require(`./assets/theme/${getReseller.id}/images/${getReseller.taurus_logo}.png`)" class="brand-logo col-sm-12" id="main-logo" alt="main-brand-logo"/>
            <span>In association with</span>
            <img :src="require(`./assets/theme/${getReseller.id}/images/${getReseller.logo}.png`)" class="brand-logo" id="sub-logo" alt="main-brand-sub-logo"/>
          </div>
          <div v-if="isTiga && !isTif">
            <img v-if="hasNoGroup" :src="require(`./assets/theme/${getReseller.id}/images/${getReseller.logo}.png`)" class="brand-logo" alt="main-brand-logo" />
            <img v-else :src="require(`./assets/theme/${getGroupResellerInfo.id}/images/${getGroupResellerInfo.logo}.png`)" 
             hspace="25" 
             vspace="25" 
             class="brand-logo" 
             :style="{'width': window.width <= 575 ? getGroupResellerInfo.logo_width_small : getGroupResellerInfo.logo_width, 
                      'height': getGroupResellerInfo.logo_height, 
                      'margin-left': getGroupResellerInfo.logo_margin_left}" 
             alt="logo"/>
          </div>
                    
        </template>
      </page-header>
      <leadarticle />
      <main class="container pb-3 pt-3 main-container">
        <router-view name="main"/>
      </main>
      <page-footer>
        <template v-slot:top>
            <p v-if="showLegalText || showfcaText" v-html="getReseller.displayName + ' ' + getMasterInfo.underwriter"></p>
        </template>
         <template v-slot:main>
          <p v-if="showLegalText" v-html="getReseller.legalText"></p>
          <p v-if="showfcaText" v-html="getReseller.fcaText"></p>
          
          <p v-html="getReseller.footerText1"></p>
          <p v-html="getReseller.footerText2"></p>
        </template>
        <template v-slot:copyright>
          <p>© {{ getCurrentYear }} {{getMasterInfo.copyright}}</p>
        </template>
      </page-footer> 
    </div>
    <backtoTop/>
    <claim-guide-tab v-if="getReseller.claimGuideTab === 'true'"></claim-guide-tab>
  </div>
</template> 

<script>


import backtoTop from "@/components/taurus-backtotop/components/BacktoTop.vue";
import pageHeader from "@/components/PageHeaderV2.vue";
import pageFooter from "@/components/PageFooterV2.vue";
import claimGuideTab from '@/components/ClaimGuideTab.vue';
import leadarticle from "./views/LeadArticle.vue";
import {mapGetters} from 'vuex';

export default {
  name: "App",
  components: {
    backtoTop,
    pageHeader,
    pageFooter,
    claimGuideTab,
    leadarticle
  },
  data: () => ({
    window: {
      width: 0,
      height: 0
    }
  }),
  beforeCreate() {
    this.$store.commit("initialise");
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
    //console.log('-r: ', this.getReseller)
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    policyReseller(val) { //watches for changes and updates groupResellerInfo
      this.$store.dispatch('reseller/findGroupReseller', val)
    }
  },
  computed: {
    ...mapGetters({      
      getMasterInfo: 'reseller/getMasterInfo' ,
      getReseller: 'reseller/getResellerInfo',
      getGroupResellerInfo: 'reseller/getGroupReseller',
      policyReseller: 'reseller/resellerId' //returns reseller id     
    }),
    getCurrentYear() {
      return new Date().getFullYear();
    },
    showLegalText() {
      if (this.getReseller.legalText)
        return true
      else
        return false
      //return this.getReseller.legalText !== '' && this.getReseller.legalText !== null
    },
    showfcaText() {
      if (this.getReseller.fcaText)
        return true
      else
        return false
      //return this.getReseller.fcaText !== '' && this.getReseller.fcaText !== null
    },
    showStandardLogo() {
      return this.getGroupResellerInfo === '' 
        || Object.keys(this.getGroupResellerInfo).length === 0 
        && this.getGroupResellerInfo.constructor === Object;
    },
    showInAssociationLogo() {
      return process.env.VUE_APP_RESELLER_ID == 1001;
    },
    isStandalone() {
      return process.env.VUE_APP_FORM_TYPE == 'standalone';
    },
    isTiga() {
      return process.env.VUE_APP_FORM_TYPE == 'tiga' || process.env.VUE_APP_FORM_TYPE == 'tigaIE';
    },
    isTga() {
      return process.env.VUE_APP_FORM_TYPE == 'tga';
    },
    isPolFed() {
      return process.env.VUE_APP_FORM_TYPE == 'polfed';
    },
    isTif() {
      return process.env.VUE_APP_RESELLER_ID == 1001;
    },
    hasNoGroup() {
      return this.getGroupResellerInfo === '' 
        || Object.keys(this.getGroupResellerInfo).length === 0 
        && this.getGroupResellerInfo.constructor === Object;
    },
    leadImageExt() {
      if (this.getReseller.leadImageExt)
         return this.getReseller.leadImageExt
      else
        return `jpg`
    },
    leadImage () {
      if (this.getReseller.leadImage)
          return this.getReseller.leadImage
      else
          return 'gadgets'
    }
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    }
  }
};
</script>
 